import { useOverlayStore } from '@features/overlay/model'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



export default function Overlay () {
  const { isOpen } = useOverlayStore()

  return (
    <div
      className={cn(styles.root, {
        [styles._show]: isOpen,
      })}
    ></div>
  )
}
